var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMarket = function SvgMarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.264.627C1.12.627.208 1.537.208 2.683V18.57c0 1.145.91 2.056 2.056 2.056h17.65c1.146 0 2.057-.91 2.057-2.056V2.683c0-1.146-.91-2.056-2.056-2.056H2.264Zm1.293 5.756h15.066c.44 0 .822.323.822.734v10.28c0 .41-.382.734-.822.734H3.557c-.441 0-.823-.323-.823-.735V7.117c0-.41.382-.734.823-.734Z",
    fill: "#546F7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.167 7.646H4.173v4.082h3.994V7.646ZM13.19 7.646H9.194v4.082h3.994V7.646ZM8.167 12.668H4.173v4.082h3.994v-4.082ZM13.19 12.668H9.194v4.082h3.994v-4.082ZM18.388 7.646h-3.994v4.082h3.994V7.646ZM18.388 12.668h-3.994v4.082h3.994v-4.082Z",
    fill: "#546F7A"
  })));
};

export default SvgMarket;